import axios from "axios";
const BASE_URL= "https://gg-api.nationtonation.ca/api/notifications"

// const BASE_URL = "https://gg-api.nationtonation.ca/api/notifications";

export const fetchAdminNotifications = async () => {
  try {
    const response = await axios.get("https://gg-api.nationtonation.ca/api/notifications/admin", {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching admin notifications:", error);
    throw error;
  }
};

export const markNotificationAsRead = async (notificationId: number) => {
  try {
    await axios.put(
      `${BASE_URL}/${notificationId}/read`,
      {},
      { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
    );
  } catch (error) {
    console.error("Error marking notification as read:", error);
    throw error;
  }
};